import React from 'react';
import PropTypes from 'prop-types';

import { CDN_URL } from '../../constants';

const EventCardLarge = ({ description, title, thumbnail, permalink }) => {
  if (!title || !permalink) {
    return null;
  }

  return (
    <div className='event-card-large'>
      {thumbnail && (
        <div className='event-card-large__media'>
          <a
            href={permalink}
            className='event-card-large__media-link'
            rel='noreferrer'
            target='_blank'
          >
            <img src={`${CDN_URL}${thumbnail}`} alt={title} className='event-card-large__img' />
          </a>
        </div>
      )}
      <div className='event-card-large__content'>
        {title && (
          <div className='event-card-large__title'>
            <a
              href={permalink}
              className='event-card-large__title-link'
              rel='noreferrer'
              target='_blank'
            >
              {title}
            </a>
          </div>
        )}
        {description && (
          <div
            className='event-card-large__description'
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
      </div>
    </div>
  );
};

EventCardLarge.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string,
  thumbnail: PropTypes.string,
  permalink: PropTypes.string,
};

export default EventCardLarge;
